import { makeStyles } from "tss-react/mui"
import { inputStyles } from "../../assets/inputStyles"
import { spacing } from "../../assets/spacing"

export const useStyles = makeStyles()((theme) => ({
    ...inputStyles(theme),
    ...spacing(theme),
    root: {
        disabled: {
            color: "black[500]",
        },
    },
}))
